import React from "react";
import { Link } from "react-router-dom";
import logo1 from "../Images/logo.png";
import homeicon from "../Images/house.png";
import appointment from "../Images/appointment.png";
import logout from "../Images/logout.png";

const Header = () => {
  return (
    <div className="header">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4 col-12">
            <div className="logo">
              <Link to="/">
                <img src={logo1} alt="" />
              </Link>
            </div>
          </div>
          <div className="col-md-8 col-12 d-flex justify-content-md-end justify-content-center">
            <nav>
              <ul>
                <li>
                  <Link to="/">
                    <img src={homeicon} alt="" /> <br />
                    Home
                  </Link>
                </li>

                <li>
                  <img src={appointment} alt="" /> <br />
                  Appointment
                </li>
                <li>
                  <Link to="/logout">
                    <img src={logout} alt="" /> <br />
                    Logout
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
